<template>
  <div>
    <div class="title">
      <p class="mt9">借款申请关闭</p>
      <p v-html="`该次借款申请已关闭，您可重新发起提现<br/>也可购买svip解锁专属借款通道`" class="mt6 small"></p>
    </div>
    <section class="jin-rong">
      <div class="more-top">
        <div class="more-left">SVIP专享权益</div>
        <div class="more-right" @click="jumpVip">查看更多></div>
      </div>
      <div class="flex-sb two-car">
        <div class="li-lv" v-for="(item,index) in bigIcon" :key="index">
          <img :src="item.icon"/>
          <div class="li-lv-content">
            <p>{{item.title}}</p>
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
      <div class="flex-sb three-car">
        <div class="item" v-for="(item,index) in smallIcon" :key="index">
          <img :src="item.icon"/>
          <p class="item-title">{{item.title}}</p>
          <p>{{item.content}}</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    lockAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      smallIcon: [
        { icon: require('../images/quanyi2.png'), title: '优先放款', content: '审核提速95%' },
        { icon: require('../images/quanyi3.png'), title: '首拒可退', content: '7日内可申请退款' },
        { icon: require('../images/icon_04@2x.png'), title: '惠享生活', content: '视频/美食5折起' }
      ]
    }
  },
  computed: {
    bigIcon () {
      return [
        { icon: require('../images/icon_001@2x.png'), title: '利率优惠67折', content: '每借一万省708元' },
        { icon: require('../images/icon_002@2x.png'), title: `提额${this.lockAmount}元`, content: '1次到账' }
      ]
    }
  },
  methods: {
    jumpVip () {
      this.$emit('jumpVip')
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../../../assets/less/mixin.less";

.title{
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .small{
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .flex-sb{
    display: flex;
    justify-content:space-between;
  }
  .jin-rong{
    width: 690px;
    margin:51px auto 0;
    background: #FFFFFF;
    box-shadow: 5px 10px 20px 0px #EEEEEE;
    border-radius: 20px;
    padding:43px 0 56px;
    .more-top{
      display:flex;
      justify-content: space-between;
      align-items: center;
      padding:0 30px;
    }
    .more-left{
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .more-right{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    &-title{
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .two-car{
      width:610px;
      margin:30px auto 0;
        .li-lv{
        display:flex;
        flex-direction: column;
        justify-content: center;
        width: 282px;
        height: 250px;
        background: #FFF7E5;
        border-radius: 10px;
        // padding-left:35px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        align-items: center;
        text-align: center;
        &-content{
          margin-top:27px;
        }
        >img{
          width:97px;
          height:97px;
        }
      }
    }
    .three-car{
      margin:30px 0 0;
      text-align:center;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      .item{
        width:230px;
        >img{
          width:70px;
          height:70px;
        }
        .content{
          color: #999999;
        }
        &-title{
          margin-top:7px;
        }
      }
    }
  }
</style>